import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Write = function Write(props) {
  useDeprecatedComponentWarning({
    component: 'Write'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M1859 447q60 62 60 148 0 85-60 147l-193 192-520-521 192-192q61-61 147-61t147 61zm-113 181q13-12 13-33t-13-34l-227-227q-14-14-34-14t-34 14l-79 79 294 295zm-895 895l612-612 113 113-639 639-785 264 265-784 638-639 113 113-612 612-111 330 76 75zm-174-120q-24-22-24-56 0-33 24-57l582-582 113 113-582 582q-24 24-57 24t-56-24z"
  }));
};

Write.displayName = 'Write';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Write.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Write;